import {
  ChargeItemDefinitionCode,
  Currency,
  type ObjectType,
} from '@quromedical/fhir-common';
import * as yup from 'yup';

import {
  type ChargeItemDefinitionMoney,
  type ChargeLine,
  type ChargeLineApplicability,
  type CreateChargeItemDefinition,
  chargeItemDefinitionChargeLineType,
  MONEY_FACTOR,
} from './schema';

const codeSchema = yup
  .string()
  .equals(Object.values(ChargeItemDefinitionCode))
  .required();

const moneySchema = yup.object<ObjectType<ChargeItemDefinitionMoney>>({
  factor: yup.number().required().equals([MONEY_FACTOR]),
  currency: yup.string().equals(Object.values(Currency)).required(),
  value: yup.number().integer().positive().required(),
});

const applicabilitySchema = yup.object<ObjectType<ChargeLineApplicability>>({
  administratorCode: yup.string().notRequired(),
  schemeCode: yup.string().notRequired(),
});

// const chargeLineTypes = ['base', 'deduction', 'discount', 'informational', 'surcharge', 'tax'];
const chargeLineTypeSchema = yup
  .string()
  .equals([...chargeItemDefinitionChargeLineType])
  .required();

const chargeLineSchema = yup
  .object<ObjectType<ChargeLine>>({
    amount: moneySchema,
    type: chargeLineTypeSchema,
    applicability: applicabilitySchema,
    code: yup.string().required(),
  })
  .required();

export const createChargeItemDefinitionSchema = yup.object<
  ObjectType<CreateChargeItemDefinition>
>({
  code: codeSchema,
  title: yup.string().required(),
  description: yup.string().required(),
  date: yup.date().required(),
  chargeLines: yup.array(chargeLineSchema).min(1).required(),
});

export const updateChargeItemDefinitionSchema =
  createChargeItemDefinitionSchema;
